import React from "react";

import bottomLogo from "./assets/dorodouli_tsipouro_and_spirits_aspro_app.png";
import { LogoImg } from "./styledComponents/Logo";

export const WhiteLogo = () => (
  <LogoImg style={{ maxHeight: "20vh" }} src={bottomLogo} alt="logo" />
);
